import { Component, computed, input } from '@angular/core';
import { AdminIconComponent } from '../../admin/admin-icon.component';
import {
  CRM_TASK_PRIORITY_LABELS,
  type CrmTaskPriority,
} from '../../models/assigned-task.models';

@Component({
  selector: 'app-crm-task-priority-badge',
  standalone: true,
  imports: [AdminIconComponent],
  template: `
    <span [class]="klass()">
      <app-admin-icon [name]="iconName()" [size]="12" />
      {{ label() }}
    </span>
  `,
})
export class CrmTaskPriorityBadgeComponent {
  readonly priority = input.required<CrmTaskPriority>();
  readonly size = input<'sm' | 'md'>('md');

  readonly label = computed(() => CRM_TASK_PRIORITY_LABELS[this.priority()]);

  readonly iconName = computed(() => {
    return this.priority() === 'LOW' ? 'arrow-down' : 'arrow-up';
  });

  readonly klass = computed(() => {
    const priorityClass = `crm-task-badge--priority-${this.priority().toLowerCase()}`;
    const sizeClass = this.size() === 'sm' ? 'crm-task-badge--sm' : '';
    return ['crm-task-badge', priorityClass, sizeClass].filter(Boolean).join(' ');
  });
}
